import { createStore } from 'vuex'
import cart from './modules/cart'
import menu from './modules/menu'
import testimonials from './modules/testimonials'
import admin from './modules/admin'
import order from './modules/order'

export default createStore({
  modules: {
    cart,
    menu,
    testimonials,
    admin,
    order
  }
})
